import { get, writable } from "svelte/store";

/*                                */
const facetGroupSelections = writable<Map<string, string>>(new Map());

export function setFacetGroupSelection(filterId: string, selectedFacetGroup: string) {
  facetGroupSelections.update((map) => {
    const updated = new Map(map);
    updated.set(filterId, selectedFacetGroup);
    return updated;
  });
}

export function getFacetGroupSelection(filterId: string): string | undefined {
  return get(facetGroupSelections).get(filterId);
}
